<script setup lang="ts">
const emit = defineEmits(["revert"])

function handleSelect(action: "revert", toggle: () => void) {
  if (action === "revert")
    emit("revert")
  toggle()
}
</script>

<template>
  <dropdown
    anchor-x="right"
    anchor-y="bottom"
    flow-x="left"
    flow-y="down"
  >
    <template #default="{ toggle }">
      <panel-button ghost @click="toggle()">
        <template #default>
          <icon-action
            size="xs"
            type="pending"
          />
          <icon-action
            size="xs"
            type="chevron-down"
            class="chevron"
          />
        </template>
      </panel-button>
    </template>
    <template #menu="{ toggle }">
      <dropdown-menu class="dropdown-menu">
        <div class="inline-select-dropdown">
          <div
            class="inline-select-option group"
            @click="handleSelect('revert', toggle)"
          >
            Revert to this version
          </div>
        </div>
      </dropdown-menu>
    </template>
  </dropdown>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'

.dropdown-menu
  @apply my-2

.chevron
  @apply -mr-1

.inline-select-dropdown
  @apply w-50 flex flex-col gap-[#{$menu-gap-items}] px-[#{$menu-px-default}] py-[#{$menu-py-default}]

.inline-select-option
  @apply flex items-center
  @apply h-5 -m-1 p-1 gap-2
  @apply t-menu-sm text-[#{$global-t-default}]
  @apply rounded-[#{$menu-br-item}]
  &:hover
    @apply cursor-pointer
    @apply bg-[#{$menu-bg-item-hover}]
  .icon
    @apply h-4 w-4
    @apply text-[#{$global-bg-icon-secondary}]
  .check
    @apply ml-auto
</style>
